import React from "react";
import { Link } from "react-router-dom";

/**
 * Shared Vemoye wordmark — gold Satisfy handwritten style.
 * Used in Header, Footer, PreLaunchShell, MemberLayout, admin login, emails.
 * The gold colour comes from the .vemoye-wordmark class in index.css; passing
 * `color` prop overrides for dark backgrounds (footer).
 */
export const Wordmark = ({
  to = "/",
  size = 34,
  color,
  className = "",
  as = "link",
  ...rest
}) => {
  const style = { fontSize: `${size}px`, ...(color ? { color } : {}) };
  const content = <span className="vemoye-wordmark" style={style}>Vemoye</span>;
  if (as === "text") return <span className={className} {...rest}>{content}</span>;
  return (
    <Link to={to} className={`inline-flex items-center ${className}`} aria-label="Vemoye Foundation home" {...rest}>
      {content}
    </Link>
  );
};

export default Wordmark;
